import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import vuetify from './plugins/vuetify'
import uComponents from "@/components/uComponents.vue"
Vue.component("uComponents", uComponents);
import uToast from "@/components/uToast.vue";
Vue.component("uToast", uToast);
Vue.prototype.$toast = function(type, txt, timer) {
  return this.$refs.ucom.toast(type, txt, timer);
}
window.eventBus = new Vue();
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App),
}).$mount('#app')
